import { Card, Typography } from "antd";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import type { SpeciesDistribution } from "../../types/adjacent-crop";

const { Title } = Typography;

interface Props {
  data: SpeciesDistribution[];
  loading?: boolean;
}

const COLORS = [
  "#52c41a",
  "#1890ff",
  "#faad14",
  "#ff4d4f",
  "#722ed1",
  "#13c2c2",
  "#eb2f96",
  "#fa8c16",
  "#a0d911",
  "#2f54eb",
];

export const SpeciesDistributionChart = ({ data, loading }: Props) => {
  const chartData = data.map((item, index) => ({
    name: item.species,
    value: item.count,
    color: COLORS[index % COLORS.length],
    percentage: item.percentage,
  }));

  return (
    <Card loading={loading}>
      <Title level={5}>Distribución por Especie</Title>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${((percent || 0) * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
};
